import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from 'src/environments/environment';
import { lastValueFrom } from "rxjs";
import { Organization, SearchOrganization } from '../models/core/organization';
import { SitePrimaryContact } from '../models/core/user';
import { CoreSite } from 'src/app/models/core/coresite';

@Injectable({
  providedIn: 'root'
})
export class CommonCoreService {
  private COMMON_CORE_SERVICE_URL = environment.commonCoreService.url + environment.commonCoreService.apiVersion; 
  constructor(private http: HttpClient) { }

  getOrganizations(searchOrganization:SearchOrganization){
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.post<any>(this.COMMON_CORE_SERVICE_URL + 'organizations/search', searchOrganization))
          .then((response?: any) => {
            resolve(response!);
          },
            (err) => {
              reject(err);
            });
     
    });
  }
  getDepartmentByOrganizationId(organizationId:string){
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(this.COMMON_CORE_SERVICE_URL + 'sites/' + organizationId + '/departments/search?departmentName=all'))
          .then((response?: any) => {
            resolve(response!);
          },
            (err) => {
              reject(err);
            });
     
    });
  }
  getCountries(){
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(this.COMMON_CORE_SERVICE_URL + 'countries'))
          .then((response?: any) => {
            resolve(response!);
          },
            (err) => {
              reject(err);
            });
     
    });
  }
  searchSitesForVerification(coreSiteDto:CoreSite){
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.post<any>(this.COMMON_CORE_SERVICE_URL + 'sites/verify/1/20/',coreSiteDto))
          .then((response?: any) => {
            resolve(response!);
          },
            (err) => {
              reject(err);
            });
     
    });
  }
  createSite(site:Organization){
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.post<any>(this.COMMON_CORE_SERVICE_URL + 'sites',site))
          .then((response?: any) => {
            resolve(response!);
          },
            (err) => {
              reject(err);
            });
     
    });    
  }
  createdepartment(siteId:string,department:Organization){
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.post<any>(this.COMMON_CORE_SERVICE_URL + 'sites/' + siteId + '/departments',department))
          .then((response?: any) => {
            resolve(response!);
          },
            (err) => {
              reject(err);
            });
     
    });    

  }
  getSiteByMedptSiteId(medptSiteId:number){
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(this.COMMON_CORE_SERVICE_URL + 'sites/medptSiteId/' + medptSiteId))
          .then((response?: any) => {
            resolve(response!);
          },
            (err) => {
              reject(err);
            });
     
    });
  }
  manageSitePrimaryContact(sitePrimaryContact:SitePrimaryContact){
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.post<any>(this.COMMON_CORE_SERVICE_URL + 'sites/' + sitePrimaryContact.SiteId + '/siteprimarycontact',sitePrimaryContact))
          .then((response?: any) => {
            resolve(response!);
          },
            (err) => {
              reject(err);
            });
     
    });    
  }
    getStudy(studyId:string){
    return new Promise<any>((resolve, reject) => {
      lastValueFrom(this.http.get<any>(this.COMMON_CORE_SERVICE_URL + 'studies/' + studyId))
          .then((response?: any) => {
            resolve(response!);
          },
            (err) => {
              reject(err);
            });
     
    });
  }
}
